import { Table, message } from 'antd';
// import { AgentPagedList } from 'api/agent';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { createContext, useEffect, useState, useCallback } from 'react';
import FilterColumns from './FilterColumns';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import {
  PresentmentDashboard,
  presentmentDashboardFilter,
  PresentmentFilterPaylaod,
  PresentmentPagedList,
} from 'api/nach';
import { usePresentmentFilterContext } from 'features/nach/presentment/context/PresenmentFilterProvider';

// let payPagedList: AgentPagedList;
// Initial state for the paginated list
const initialPresentmentPagedList: PresentmentPagedList = {
  currentPageIndex: 1, // Or 0, depending on your API's first page index
  noOfRecords: 0,
  data: [],
};

type Props = {
  filter: PresentmentFilterPaylaod;
  reload: boolean;
};

function getFullDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('YYYY/DD/MM HH:mm:ss');
    return dateMoment;
  }
}

export const ReloadFilterListContext = createContext<any>(null);

const FilteredNoMappingPresentmentList = ({ }: Props) => {
  // const [pagedList, setPagedList] = useState<PresentmentDashboard[]>([]);
  const [pagedList, setPagedList] = useState<PresentmentPagedList>(initialPresentmentPagedList); // Use PresentmentPagedList

  const [isLoading, setIsLoading] = useState(false);
  const { filter, currentActiveTabKey, prevFilter, setFilter } = usePresentmentFilterContext();
  const [fetchedDate, setFetchedDate] = useState('');
  const [isRetry, setIsRetry] = useState(false);

  // Local state for pagination parameters
  // const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Default page size

  // filter.Username = sessionStorage.getItem('user')?.toString();
  const isAdmin = sessionStorage.getItem('isAdmin');

  if (isAdmin != 'true') {
    // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  }

  useEffect(() => {


    console.log("-No loan type mapping filters currecnt tab:", currentActiveTabKey)
    if (!filter || !filter.startDate || !filter.endDate) {
      setIsLoading(true);
      setPagedList(initialPresentmentPagedList);
      // message.warn('Please select date');
      return;
    }
    if (filter?.isExtract && currentActiveTabKey == 5) {
      console.log("---DOWNLOAD TRIGGERED for no loan type mapping---", filter);
      handleDownloadData();
      return
    }
    console.log("sssssssssssssssss");
    // if (!filter || !filter.startDate || !filter.endDate) {
    //   setIsLoading(true);
    //   // message.warn('Please select date');
    //   return;
    // }
    if (currentActiveTabKey != 5 && prevFilter != JSON.stringify(filter)) {
      return;
    }
    const filterForTableFetch = { ...filter };
    delete filterForTableFetch.isExtract;
    delete filterForTableFetch.pageNo;
    delete filterForTableFetch.pageSize;
    const filterForTableFetchString = JSON.stringify(filterForTableFetch);
    if (fetchedDate != filterForTableFetchString && currentActiveTabKey == 5) {
      setFetchedDate(filterForTableFetchString);
      setIsLoading(false);
      //  setPagedList([]);
      setPagedList(initialPresentmentPagedList); // Reset pagedList when filter changes
      //      const newFilter: PresentmentFilterPaylaod = { ...filter, presentmentFlagId: 0 };
      const newFilter: PresentmentFilterPaylaod = {
        ...filter,
        presentmentFlagId: 0,
        pageNo: 1, // Always start at page 1 for a new filter fetch
        pageSize: pageSize, // Use current pageSize
      };
      presentmentDashboardFilter(newFilter)
        .then((res) => {
          console.log('no mapping data presentment', res);
          if (res.data) {
            setPagedList(res.data);
          }
        })
        .finally(() => {
          setIsLoading(true);
        });
    }
  }, [filter, currentActiveTabKey, pageSize, isRetry]);

  const handleDownloadData = useCallback(() => {
    const downloadPayload: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 0, // Assuming this is the correct flag for this list
      isExtract: true, // Confirming extraction
      pageNo: 1, // Or a value your backend understands as "all pages"
      pageSize: pageSize, // Or a value your backend understands as "all items"
    };

    presentmentDashboardFilter(downloadPayload)
      .then((res) => {
        console.log('Download data fetched', res);
        if (res.data && res.data.data.length > 0) { // Ensure res.data and res.data.data exist
          console.log('Data check res.data.data.length', res.data.data.length);
          performExcelDownload(res.data.data); // Pass the actual data array
        } else {
          console.log('No data found for download.', res.data);
          message.destroy();
          message.error('No data found for download in No Loan Type Mapping');
        }
      })
      .catch((error) => {
        console.error('Error fetching data for download:', error);
        message.error('Failed to download data.');
      })
      .finally(() => {
        //setIsLoading(true); // Hide loading after download attempt
        //const resetFilter = { ...filter, isExtract: false };
        //setFilter(resetFilter);
        //message.destroy(); // Hide loading message
        setFilter((prevFilter: PresentmentFilterPaylaod) => ({
          ...prevFilter,
          isExtract: false,
        }));
      });
  }, [filter, setFilter]);
  const performExcelDownload = (dataToDownload: PresentmentDashboard[]) => {
    let settings = {
      fileName: 'presentment_no_loan_mapping',
      extraLength: 3,
      writeMode: 'writeFile',
      writeOptions: {},
      RTL: false,
    };

    const updatedData = dataToDownload.map((item: any, index) => ({
      ...item,
      NOTIFICATIONDATE: getFullDate(item.notificationDate),
      DATEOFTXN: getFullDate(item.dateOfTxn),
      CREATEDON: getFullDate(item.createdOn),
      ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
    }));

    let data = [
      {
        sheet: 'Sheet 1',
        columns: [
          { label: 'ROWNUM', value: 'ROWNUM' },
          { label: 'UMRN NO', value: 'umrnNO' },
          { label: 'Corporate Name', value: 'corporateName' },
          { label: 'Corporate User No', value: 'corporateUserNo' },
          { label: 'Amount', value: 'amount' },
          { label: 'Transaction ID REF', value: 'transactionIDREF' },
          { label: 'Unique Reference', value: 'uniqueReference' },
          { label: 'Batch No', value: 'batchNo' },
          { label: 'Created On', value: 'CREATEDON' },
          { label: 'Customer Debit AC', value: 'customerDebitAC' },
          { label: 'Customer MICR', value: 'customerMICR' },
          { label: 'Date Of Transaction', value: 'DATEOFTXN' },
          { label: 'Debitor Name', value: 'debtorName' },
          { label: 'IFSC', value: 'ifsc' },
          { label: 'Loan Type', value: 'loanType' },
          { label: 'Merchant Order Id', value: 'merchantOrderId' },
          { label: 'Merchant Subscription Id', value: 'merchantSubscriptionId' },
          { label: 'Notification Date', value: 'NOTIFICATIONDATE' },
          { label: 'Notify Response Order ID', value: 'notifyResponseOrderID' },
          { label: 'Partner Bank', value: 'partnerBank' },
          { label: 'Pre Notification Status', value: 'preNotificationStatus' },
          { label: 'Presentment Flag', value: 'presentmentFlag' },
          { label: 'Presentment Id', value: 'presentmentId' },
          { label: 'Presentment Status', value: 'presentmentStatus' },
          { label: 'Sourcing Type', value: 'sourcingType' },
          { label: 'Created By', value: 'createdBy' },
        ],
        content: updatedData,
      },
    ];
    xlsx(data, settings);
  };

  if (!isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    setIsLoading(false);
    setPageSize(_pagination.pageSize);

    // filter.Username = sessionStorage.getItem('user')?.toString();
    if (isAdmin != 'true') {
      // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    }

    // filter.PageNo = _pagination.current;
    // filter.PageSize = _pagination.pageSize;
    // const newFilter: PresentmentFilterPaylaod = { ...filter, presentmentFlagId: 1 };
    const newFilter: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 0,
      pageNo: _pagination.current, // Use the page from Ant Design's pagination
      pageSize: _pagination.pageSize, // Use the page size from Ant Design's pagination
    };
    presentmentDashboardFilter(newFilter)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  const maxWidthPerCell = 600;

  const dataTable = calculateColumnsWidth(FilterColumns, pagedList.data || [], maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <ReloadFilterListContext.Provider value={{ setIsRetry, isRetry }}>
      <Table
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={rowKey}
        //pagination={false}
        // pagination={
        //   {
        //     // pageSize: 10,
        //     // total: pagedList.noOfRecords - 10,
        //     // current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
        //   }
        // }
        pagination={{
          pageSize: pageSize, // Use the state variable for page size
          total: pagedList.noOfRecords, // Total records from your API response
          current: pagedList.currentPageIndex === 0 ? 1 : pagedList.currentPageIndex, // Current page from your API response
          showSizeChanger: true, // Allow changing page size
          pageSizeOptions: ['10', '20', '50', '100'], // Options for page size
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`, // Optional: show total items
        }}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        onChange={handleChange}
      />
    </ReloadFilterListContext.Provider >
  );
};
export default FilteredNoMappingPresentmentList;
